module.exports = __webpack_public_path__ + "img/inactive.2ebe5c80.png";